import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useRef } from 'react';
import { ErrorMessage } from '../input-message/input-message.js';
import { containerStyles, spanStyles, textareaWrapperStyles, textareaStyles, errorMessageStyles } from './textarea.css.js';

function Textarea({
  autoExpand = false,
  caption,
  className,
  defaultValue,
  errorMessage,
  id,
  name,
  onChange,
  onInput,
  placeholder,
  resize = false,
  value,
  ...rest
}) {
  const parentReference = useRef(null);
  function onInputChange(event) {
    if (parentReference.current) {
      parentReference.current.dataset.replicatedValue = event.target.value;
    }
    onInput?.(event);
  }
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { className: containerStyles, children: [
      caption && /* @__PURE__ */ jsx("span", { className: spanStyles, children: caption }),
      /* @__PURE__ */ jsx("div", { className: textareaWrapperStyles, ref: parentReference, "data-expand": autoExpand || undefined, children: /* @__PURE__ */ jsx(
        "textarea",
        {
          className: clsx(textareaStyles({ resize }), className),
          "data-error": Boolean(errorMessage),
          defaultValue,
          id,
          name,
          onChange,
          placeholder,
          value,
          ...rest,
          onInput: onInputChange
        }
      ) })
    ] }),
    errorMessage && /* @__PURE__ */ jsx(ErrorMessage, { className: errorMessageStyles, children: errorMessage })
  ] });
}

export { Textarea, Textarea as default };
